// Knowledge Hub topic content. Indian market data updated to current (Dec 2025):
// • Nifty lot size: 75 | Bank Nifty lot size: 30 | Sensex lot size: 20
// • Index weekly expiry: Tuesday (Nifty), no weekly for Bank Nifty/Fin Nifty/Sensex weekly Tuesday
// • Stock options: monthly only, last Thursday of expiry month

export const TOPICS = [
  { id: "option-trading", title: "Option Trading", group: "Basics" },
  { id: "futures-options", title: "Futures & Options (F&O)", group: "Basics" },
  { id: "algo-trading", title: "Algo Trading", group: "Advanced" },
  { id: "adjustment", title: "Adjustment in Trading", group: "Advanced" },
  { id: "hedging", title: "Hedging", group: "Advanced" },
  { id: "risk-management", title: "Risk Management", group: "Advanced" },
  { id: "quant-trading", title: "Quant Trading", group: "Advanced" },
  { id: "algo-vs-quant", title: "Algo vs Quant", group: "Advanced" },
  { id: "option-greeks", title: "Option Greeks", group: "Options" },
  { id: "option-chain", title: "Option Chain", group: "Options" },
  { id: "indicators", title: "Indicators", group: "Tools" },
  { id: "india-vix", title: "India VIX", group: "Tools" },
  { id: "nifty-50", title: "Nifty 50", group: "Indices" },
  { id: "bank-nifty", title: "Bank Nifty", group: "Indices" },
  { id: "sensex", title: "Sensex", group: "Indices" },
  { id: "bankex", title: "Bankex", group: "Indices" },
  { id: "intraday-strategies", title: "Intraday Strategies", group: "Strategies" },
  { id: "positional-strategies", title: "Positional Strategies", group: "Strategies" },
];

export const GROUPS = ["Basics", "Options", "Tools", "Indices", "Advanced", "Strategies"];
